module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADkSURBVEhL7ZPLCcJQEEWDWEDaSRF+qrAEExTby9qNYAPqStwJirx4R4+ijJgfuAgeeLzkfmaySdQtiqIYhxC2ut8wTWdErDkasmOmQ96GWHOYVfD6BNnptWHObRCP7rkVzOnIgleQ/wt+uKAtjPPob92TaYxmHBnnkZkTSpEqo1pGd4nkkTkjtNLVRy7FsuqsrSsyZI/MWMGDpXTPkUtRdkHHujHyZxQa6jyYqtDDcpinTHqPhovOAOs7Kk4UPuu2r8qRHeaROVkHuRoqJVY2kBzYtiBBqgf9UojXh34pxDtJFF0BgZhb9wVgMncAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-toilet-bowl/light/24.png
// module id = 2504
// module chunks = 2